<script lang="ts">
  import AdminView from "./AdminView.svelte";
  import IntroBlock from "./Block.svelte";
  import type { Operator } from "@/src/types/components/operators/Operator";
  import type { IntroProps } from "@/src/types/components/Intro";

  export let props: IntroProps;
  export let adminView: boolean = false;
  export let operator: Operator | undefined;
  export let methodology: boolean = false;
  export let methodologyText: string = "";
  export let recentChanges: boolean = false;
  export let recentChangesList: string[] = [];
  export let crm: boolean = false;
  export let crmText: string = "";
</script>

{#if adminView}
  <AdminView {props} />
{:else}
  <IntroBlock {props} {operator} {methodology} {methodologyText} {recentChanges} {recentChangesList} {crm} {crmText} />
{/if}
